import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function SecurityPage() {
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const sidebar = document.getElementById('sidebar');
    const closeSidebar = document.querySelector('.close-sidebar');
    if (hamburger && sidebar && closeSidebar) {
      hamburger.onclick = () => sidebar.classList.add('active');
      closeSidebar.onclick = () => sidebar.classList.remove('active');
    }
    return () => {
      if (hamburger) hamburger.onclick = null;
      if (closeSidebar) closeSidebar.onclick = null;
    };
  }, []);

  return (
    <main className="security-page">
      <nav className="regular-navbar">
        <Link className="logo" to="/">
          <img src="/logo.jpg" alt="company logo" />
        </Link>
        <div className="hamburger">
          <img src="/static/media/hamburger-black.c116047ebd06e70caac47be95fd90698.svg" alt="menu" />
        </div>
        <div className="links">
          <div className="void"></div>
          <div className="cont">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/loans">Loans</Link></li>
              <li><Link to="/savings-investments">Savings & Investment</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
            <div className="btns">
              <button className="transparent"><Link to="/register">Register</Link></button>
              <button className="blue"><Link to="/login">Sign In</Link></button>
            </div>
          </div>
        </div>
      </nav>
      <div id="sidebar">
        <ul>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <div className="close-sidebar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </div>
          </div>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/loans">Loans</Link></li>
          <li><Link to="/savings-investments">Savings & Investment</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <div className="btnss" style={{ marginTop: 14 }}>
            <button className="transparent" style={{ marginRight: 5 }}><Link to="/register">Register</Link></button>
            <button className="blue"><Link to="/login">Sign In</Link></button>
          </div>
        </ul>
      </div>
      <header className="page-header">
        <div className="text-info">
          <h1>Security</h1>
          <p>Your security is our top priority. We use advanced security measures to protect your personal and financial information, and we are committed to keeping your data safe and secure at all times.</p>
        </div>
        <div className="img">
          <img src="/static/media/security-page-header.webp" alt="Security" />
        </div>
      </header>
      <section className="security-section">
        <h2>Our Security Measures</h2>
        <ul>
          <li>End-to-end encryption</li>
          <li>Multi-factor authentication</li>
          <li>Fraud monitoring and alerts</li>
          <li>Regular security audits</li>
        </ul>
      </section>
      <footer className="footer">
        <div className="grid">
          <div className="item logo-info">
            <div className="logo"></div>
          </div>
          <div className="item socials">
            <h3>Follow us</h3>
            <ul>
              <li><a href="#"><i className="fa fa-facebook"></i></a></li>
              <li><a href="#"><i className="fa fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
